import { motion } from "framer-motion";
import { X } from "lucide-react";

export const FeatureModal = ({ feature, onClose }) => {
  const closeFromBackdrop = (event) => {
    if (event.target === event.currentTarget) onClose();
  };

  return (
  <motion.div className="modal-backdrop" role="presentation" onClick={closeFromBackdrop} data-testid="feature-modal-backdrop" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
    <motion.div className={`feature-modal${feature.modalFeatures ? " feature-modal-detailed" : ""}`} role="dialog" aria-modal="true" aria-labelledby="feature-modal-title" data-testid="feature-modal" initial={{ opacity: 0, scale: .94, y: 12 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: .96, y: 8 }} transition={{ duration: .22 }}>
      <button className="modal-close" type="button" aria-label="Close feature details" onClick={onClose} data-testid="feature-modal-close-button"><X aria-hidden="true" /></button>
      <div className="feature-modal-content">
        <h2 id="feature-modal-title" className="modal-title" data-testid="feature-modal-title">{feature.title}</h2>
        {feature.modalDescription ? <p className="modal-description" data-testid={`feature-modal-description-${feature.id}`}>{feature.modalDescription}</p> : null}
        {feature.modalFeatures ? (
          <section className="modal-features" data-testid={`feature-modal-features-${feature.id}`}>
            <h3 data-testid={`feature-modal-heading-${feature.id}`}>{feature.modalHeading}</h3>
            <ul>
              {feature.modalFeatures.map((item, index) => (
                <li key={item} data-testid={`feature-modal-item-${feature.id}-${index + 1}`}>{item}</li>
              ))}
            </ul>
          </section>
        ) : null}
        {feature.modalTagline ? <p className="modal-tagline" data-testid={`feature-modal-tagline-${feature.id}`}>{feature.modalTagline}</p> : null}
      </div>
    </motion.div>
  </motion.div>
  );
};